define('lib/backbone/Backbone.PodioController',['require','underscore','backbone','backbone-super','lib/backbone/Backbone.PodioView','lib/backbone/Backbone.PodioEvents','lib/backbone/Backbone.Mixins.Transport'],function(require) {

  var _ = require('underscore');
  var Backbone = require('backbone');
  require('backbone-super');

  var PodioView = require('lib/backbone/Backbone.PodioView');
  var PodioEvents = require('lib/backbone/Backbone.PodioEvents');
  var MixinTransport = require('lib/backbone/Backbone.Mixins.Transport');

  var PodioController = PodioView.extend({

    initialize: function() {
      if (this.options && this.options.eventBus) {
        this.eventBus = this.options.eventBus;
      } else {
        this.eventBus = _.extend({}, PodioEvents);
      }

      this._super();
    }

  });

  _.extend(PodioController.prototype, MixinTransport);

  //Exports
  Backbone.PodioController = PodioController;

  return PodioController;

});

